export const ReportIssueReasons = {
  INACCURATE_FEEDBACK: 'INACCURATE_FEEDBACK',
  NOT_HELPFUL_FEEDBACK: 'NOT_HELPFUL_FEEDBACK',
  NEED_HELP_PLATFORM: 'NEED_HELP_PLATFORM',
  BUG_ON_PLATFORM: 'BUG_ON_PLATFORM',
  REASON_NOT_LISTED: 'REASON_NOT_LISTED'
};

export const reportIssueReasonsList = [
  { text: 'JeddAI feedback was inaccurate', key: ReportIssueReasons.INACCURATE_FEEDBACK },
  { text: 'JeddAI feedback was not helpful', key: ReportIssueReasons.NOT_HELPFUL_FEEDBACK },
  { text: 'I need help using the platform', key: ReportIssueReasons.NEED_HELP_PLATFORM },
  { text: 'There is a bug on the platform', key: ReportIssueReasons.BUG_ON_PLATFORM },
  { text: 'My reason is not listed here', key: ReportIssueReasons.REASON_NOT_LISTED }
];
